// --- Components
import * as usersColumns from "../../../pages/Users/components/grid/config/columns";
import * as pmxDeliveriesColumns from "../../../pages/PMXDeliveries/components/grid/config/columns";
import * as pmxPricesAndDatesColumns from "../../../pages/PMXPricesAndDates/components/grid/config/columns";
import * as tapJobColumns from "../../../pages/TAPJobs/components/grid/config/columns";
import * as jobTaskColumns from "../../../pages/TAPJobs/components/modals/tasks/grid/config/columns";
import * as updateEngineColumns from "../../../pages/UpdateEngine/components/grid/config/columns";
import * as tprExceptionColumns from "../../../pages/TPRExceptions/components/grid/config/columns";
import * as rateCardColumns from "../../../pages/RateCards/components/grid/config/columns";
import * as licJobColumns from "../../../pages/LicensingJobs/components/grid/config/columns";
import * as licJobTaskColumns from "../../../pages/LicensingJobs/components/modals/status/grid/config/columns";
import * as offerTableColumns from "../../../pages/Offers/components/grid/config/columns.jsx";
import * as offerHistoryColumns from "../../../pages/OfferHistory/components/grid/config/columns.jsx";
import * as windowsColumns from "../../../pages/Windows/components/grid/config/columns";

export const updateEngine = (onOpenJobViewModal) => ({
  default: [
    updateEngineColumns.id,
    updateEngineColumns.jobStatus(onOpenJobViewModal),
    updateEngineColumns.dealsProcessed,
    updateEngineColumns.errorCount,
    updateEngineColumns.createdAt,
    updateEngineColumns.completedAt,
  ],
});

export const tapJobs = (onOpenJobViewModal, onOpenJobTasksModal) => ({
  default: [
    tapJobColumns.id,
    tapJobColumns.jobType,
    tapJobColumns.jobStatus(onOpenJobViewModal),
    tapJobColumns.targetCount(onOpenJobTasksModal),
    tapJobColumns.progressCount,
    tapJobColumns.errorCount,
    tapJobColumns.createdBy,
    tapJobColumns.createdAt,
    tapJobColumns.completedAt,
  ],
});

export const jobViewTasks = () => ({
  default: [
    jobTaskColumns.id,
    jobTaskColumns.taskStatus,
    jobTaskColumns.statusMessage,
    jobTaskColumns.taskDetails,
    jobTaskColumns.createdAt,
    jobTaskColumns.modifiedAt,
    jobTaskColumns.completedAt,
  ],
});

export const tapJobTasks = () => ({
  default: [
    jobTaskColumns.id,
    jobTaskColumns.taskStatus,
    jobTaskColumns.statusMessage,
    jobTaskColumns.taskDetails,
    jobTaskColumns.createdAt,
    jobTaskColumns.modifiedAt,
    jobTaskColumns.completedAt,
  ],
});
export const pmxPricesAndDates = () => ({
  default: [
    pmxPricesAndDatesColumns.id,
    pmxPricesAndDatesColumns.isHistorical,
    pmxPricesAndDatesColumns.catalogId,
    pmxPricesAndDatesColumns.catalogName,
    pmxPricesAndDatesColumns.catalogTemplate,
    pmxPricesAndDatesColumns.pmxReleaseId,
    pmxPricesAndDatesColumns.territoryName,
    pmxPricesAndDatesColumns.productType,
    pmxPricesAndDatesColumns.productConfig,
    pmxPricesAndDatesColumns.productPlatform,
    pmxPricesAndDatesColumns.superPremiumEHVLStartDate,
    pmxPricesAndDatesColumns.superPremiumEHVLStartDateStatus,
    pmxPricesAndDatesColumns.superPremiumEHVLTier,
    pmxPricesAndDatesColumns.superPremiumEHVLPrice,
    pmxPricesAndDatesColumns.premiumEHVLStartDate,
    pmxPricesAndDatesColumns.premiumEHVLStartDateStatus,
    pmxPricesAndDatesColumns.premiumEHVLTier,
    pmxPricesAndDatesColumns.premiumEHVLPrice,
    pmxPricesAndDatesColumns.newReleaseEHVLStartDate,
    pmxPricesAndDatesColumns.currencyCodeEHVLPrice,
    pmxPricesAndDatesColumns.newReleaseEHVLTier,
    pmxPricesAndDatesColumns.newReleaseEHVLPrice,
    pmxPricesAndDatesColumns.newReleaseEHVLEpisodeTier,
    pmxPricesAndDatesColumns.newReleaseEHVLEpisodePrice,
    pmxPricesAndDatesColumns.newToCatalogEHVLStartDate,
    pmxPricesAndDatesColumns.newToCatalogEHVLStartDateStatus,
    pmxPricesAndDatesColumns.newToCatalogEHVLTier,
    pmxPricesAndDatesColumns.newToCatalogEHVLPrice,
    pmxPricesAndDatesColumns.catalogEHVLStartDate,
    pmxPricesAndDatesColumns.catalogEHVLStartDateStatus,
    pmxPricesAndDatesColumns.catalogEHVLTier,
    pmxPricesAndDatesColumns.catalogEHVLPrice,
    pmxPricesAndDatesColumns.catalogEHVLEpisodeTier,
    pmxPricesAndDatesColumns.catalogEHVLEpisodePrice,
    pmxPricesAndDatesColumns.presellEHVLStartDate,
    pmxPricesAndDatesColumns.presellStartEHVDateStatus,
    pmxPricesAndDatesColumns.ehvlSupressionLiftDate,
    pmxPricesAndDatesColumns.ehvlSuppressionLiftDateStatus,
    pmxPricesAndDatesColumns.ehvlSetPrice,
    pmxPricesAndDatesColumns.currencyCodeEHVLSetPrice,
    pmxPricesAndDatesColumns.tvodSuperPremiumStartDate,
    pmxPricesAndDatesColumns.tvodSuperPremiumStartDateStatus,
    pmxPricesAndDatesColumns.tvodSuperPremiumTier,
    pmxPricesAndDatesColumns.tvodSuperPremiumLicenseFee,
    pmxPricesAndDatesColumns.tvodSuperPremiumMinDeemedPrice,
    pmxPricesAndDatesColumns.tvodPremiumStartDate,
    pmxPricesAndDatesColumns.tvodPremiumStartDateStatus,
    pmxPricesAndDatesColumns.tvodPremiumTier,
    pmxPricesAndDatesColumns.tvodPremiumLicenseFee,
    pmxPricesAndDatesColumns.tvodPremiumMinDeemedPrice,
    pmxPricesAndDatesColumns.tvodCurrentStartDate,
    pmxPricesAndDatesColumns.tvodCurrentStartDateStatus,
    pmxPricesAndDatesColumns.currencyCodeTVODLicenseFee,
    pmxPricesAndDatesColumns.currencyCodeTVODMinDeemedPrice,
    pmxPricesAndDatesColumns.tvodCurrentTier,
    pmxPricesAndDatesColumns.tvodCurrentLicenseFee,
    pmxPricesAndDatesColumns.tvodCurrentMinDeemedPrice,
    pmxPricesAndDatesColumns.tvodCurrentEpisodeTier,
    pmxPricesAndDatesColumns.tvodCurrentEpisodePrice,
    pmxPricesAndDatesColumns.tvodLibraryStartDate,
    pmxPricesAndDatesColumns.tvodLibraryStartDateStatus,
    pmxPricesAndDatesColumns.tvodLibraryTier,
    pmxPricesAndDatesColumns.tvodLibraryLicensedFee,
    pmxPricesAndDatesColumns.tvodLibraryMinDeemedPrice,
    pmxPricesAndDatesColumns.tvodLibraryEpisodeTier,
    pmxPricesAndDatesColumns.tvodLibraryEpisodePrice,
    pmxPricesAndDatesColumns.tvodSupressionLiftDate,
    pmxPricesAndDatesColumns.tvodSupressionLiftDateStatus,
    pmxPricesAndDatesColumns.consumerAnnouncementDate,
    pmxPricesAndDatesColumns.physicalDate,
    pmxPricesAndDatesColumns.physicalStatus,
    pmxPricesAndDatesColumns.physicalRetailPrice,
    pmxPricesAndDatesColumns.currencyCodeWholesalePrice,
    pmxPricesAndDatesColumns.physicalWholesalePrice,
    pmxPricesAndDatesColumns.presellStartPhysicalDate,
    pmxPricesAndDatesColumns.presellStartPhysicalStatus,
    pmxPricesAndDatesColumns.created,
    pmxPricesAndDatesColumns.modified,
  ],
});

export const pmxDeliveries = () => ({
  default: [
    pmxDeliveriesColumns.id,
    pmxDeliveriesColumns.action,
    pmxDeliveriesColumns.status,
    pmxDeliveriesColumns.pmxSkuId,
    pmxDeliveriesColumns.productId,
    pmxDeliveriesColumns.releaseId,
    pmxDeliveriesColumns.name,
    pmxDeliveriesColumns.type,
    pmxDeliveriesColumns.territory,
    pmxDeliveriesColumns.releaseDate,
    pmxDeliveriesColumns.error,
    pmxDeliveriesColumns.created,
    pmxDeliveriesColumns.modified,
  ],
});

export const users = () => ({
  default: [
    usersColumns.id,
    usersColumns.username,
    usersColumns.fullName,
    usersColumns.lastLogin,
    usersColumns.status,
    usersColumns.spaUserRoleIds,
    usersColumns.rightslineId,
  ],
});

export const tprExceptions = () => ({
  default: [
    tprExceptionColumns.tprRelease,
    tprExceptionColumns.dismissed,
    tprExceptionColumns.id,
    tprExceptionColumns.exceptionStatus,
    tprExceptionColumns.exceptionType,
    tprExceptionColumns.exceptionMessage,
    tprExceptionColumns.licensee,
    //tprExceptionColumns.exceptionDetails,
    tprExceptionColumns.deal,
    tprExceptionColumns.tprCatalogId,
    tprExceptionColumns.enterpriseProductId,
    tprExceptionColumns.tprCatalog,
    tprExceptionColumns.tprTerritory,
    tprExceptionColumns.tprMedia,
    tprExceptionColumns.tprFormat,
    tprExceptionColumns.tprStartDate,
    tprExceptionColumns.tprEndDate,
    tprExceptionColumns.exceptionTimestamp,
    tprExceptionColumns.dismissBy,
  ],
});

export const rateCards = (
  onOpenViewRateCardDrawer,
  onOpenRateCardEditModal,
  isTapAdmin = false,
) => ({
  default: [
    rateCardColumns.statusIndicator,
    rateCardColumns.view(onOpenViewRateCardDrawer),
    // Only include edit column for TAP Admins
    ...(isTapAdmin ? [rateCardColumns.edit(onOpenRateCardEditModal)] : []),
    rateCardColumns.id,
    rateCardColumns.rateCardName,
    rateCardColumns.windowSequenceName,
    rateCardColumns.currency,
    rateCardColumns.priceType,
    rateCardColumns.revShareType,
    rateCardColumns.isTpr,
    rateCardColumns.status,
    rateCardColumns.createdBy,
    rateCardColumns.createdAt,
    rateCardColumns.updatedBy,
    rateCardColumns.modifiedAt,
  ],
});

export const licensingJobs = (
  onOpenViewLicensingJob,
  onOpenEditLicensingJob,
  onRunLicensingJob,
  onCheckForUpdates,
  onViewLicensingJobStatus,
  onViewOffers,
  onCopyLicensingJob,
  onInactivateLicensingJob,
  isTapAdmin = false,
) => ({
  default: [
    licJobColumns.statusIndicator,
    licJobColumns.view(onOpenViewLicensingJob),
    licJobColumns.edit(onOpenEditLicensingJob),
    licJobColumns.id,
    licJobColumns.description,
    licJobColumns.catalogs,
    licJobColumns.medias,
    licJobColumns.territories,
    licJobColumns.licenseeType,
    licJobColumns.startDate,
    licJobColumns.endDate,
    licJobColumns.isTpr,
    licJobColumns.run(onRunLicensingJob),
    licJobColumns.checkForUpdates(onCheckForUpdates),
    licJobColumns.status(onViewLicensingJobStatus),
    licJobColumns.offers(onViewOffers),
    licJobColumns.offerStatus,
    licJobColumns.latestJob,
    licJobColumns.lastRunBy,
    licJobColumns.completedAt,
    licJobColumns.createdBy,
    licJobColumns.createdAt,
    licJobColumns.updatedBy,
    licJobColumns.modifiedAt,
    licJobColumns.copy(onCopyLicensingJob),
    // Only include inactivate column for TAP Admins
    ...(isTapAdmin ? [licJobColumns.inactivate(onInactivateLicensingJob)] : []),
  ],
});

export const licensingJobTasks = () => ({
  default: [
    licJobTaskColumns.id,
    licJobTaskColumns.taskStatus,
    licJobTaskColumns.statusMessage,
    licJobTaskColumns.taskDetails,
    licJobTaskColumns.createdAt,
    licJobTaskColumns.modifiedAt,
    licJobTaskColumns.completedAt,
  ],
});

export const offerTable = ({
  onDeleteOffer,
  onPushOrUpdateOffer,
  getOfferHistoryHref,
  onEditOffer,
  onSaveOffer,
  onCancelEdit,
  getEditingRows,
  getEditedValues,
  onValueChange,
  subDubLanguageOptions,
  shouldRenderDelete,
  shouldRenderPush,
  onLanguageSelect,
  getLastSelectedLanguages,
  isTprJob,
}) => ({
  default: [
    offerTableColumns.rowActions(
      onEditOffer,
      onSaveOffer,
      onCancelEdit,
      getEditingRows,
      getEditedValues,
      onDeleteOffer,
      onPushOrUpdateOffer,
      getOfferHistoryHref,
      shouldRenderDelete,
      shouldRenderPush,
      isTprJob,
    ),
    offerTableColumns.createdAt,
    offerTableColumns.id,
    offerTableColumns.needsAudit,
    offerTableColumns.tapOfferStatus,
    offerTableColumns.offerTableRowRlId,
    offerTableColumns.licensingJobId,
    offerTableColumns.dealId,
    offerTableColumns.dealName,
    offerTableColumns.catalogId,
    offerTableColumns.catalogName,
    offerTableColumns.readyToPublish(getEditingRows, onValueChange),
    offerTableColumns.offerStatus(getEditingRows, onValueChange),
    offerTableColumns.dateTaken(getEditingRows, onValueChange),
    offerTableColumns.media,
    offerTableColumns.territory,
    offerTableColumns.languages,
    offerTableColumns.format,
    offerTableColumns.termStart(getEditingRows, onValueChange),
    offerTableColumns.termEnd(getEditingRows, onValueChange),
    offerTableColumns.startDateStatus(getEditingRows, onValueChange),
    offerTableColumns.endDateStatus(getEditingRows, onValueChange),
    offerTableColumns.rating(getEditingRows, onValueChange),
    offerTableColumns.rateCardType,
    offerTableColumns.rateCardId,
    offerTableColumns.rateCardName,
    offerTableColumns.windows,
    offerTableColumns.windowNum,
    offerTableColumns.tier(getEditingRows, onValueChange),
    offerTableColumns.licenseFee(getEditingRows, onValueChange),
    offerTableColumns.minDeemedPrice(getEditingRows, onValueChange),
    offerTableColumns.seasonPassAmt(getEditingRows, onValueChange),
    // episodeTier is in withEpisodeFeature
    offerTableColumns.pmxPlatform,
    offerTableColumns.currency,
    offerTableColumns.percentageSplit(getEditingRows, onValueChange),
    offerTableColumns.emaPriceType,
    // episodeEmaPriceType is in withEpisodeFeature
    offerTableColumns.viewingPeriod,
    offerTableColumns.preSell(getEditingRows, onValueChange),
    offerTableColumns.subLanguage(
      getEditingRows,
      onValueChange,
      subDubLanguageOptions,
      onLanguageSelect,
      getLastSelectedLanguages,
    ),
    offerTableColumns.dubLanguage(
      getEditingRows,
      onValueChange,
      subDubLanguageOptions,
      onLanguageSelect,
      getLastSelectedLanguages,
    ),
    offerTableColumns.tprProgramName(getEditingRows, onValueChange),
    offerTableColumns.ocad,
    offerTableColumns.suppressionLiftDate,
    offerTableColumns.exclusivity,
    offerTableColumns.holdbackLanguages,
    offerTableColumns.languageAvailsDisplay,
    offerTableColumns.availsTypeOverride(getEditingRows, onValueChange),
    offerTableColumns.informationalRestrictions,
    offerTableColumns.message,
  ],
  withEpisodeFeature: (getEditingRows, onValueChange) => [
    offerTableColumns.episodeTier(getEditingRows, onValueChange),
    offerTableColumns.episodeEmaPriceType,
  ],
});

export const windows = (
  onOpenViewDrawer,
  onOpenEditDrawer,
  isTapAdmin = false,
) => ({
  default: [
    windowsColumns.statusIndicator,
    windowsColumns.view(onOpenViewDrawer),
    ...(isTapAdmin ? [windowsColumns.edit(onOpenEditDrawer)] : []),
    windowsColumns.id,
    windowsColumns.windowSequenceName,
    windowsColumns.windows,
    windowsColumns.status,
    windowsColumns.createdBy,
    windowsColumns.createdAt,
    windowsColumns.updatedBy,
    windowsColumns.modifiedAt,
  ],
});

export const offerHistory = () => ({
  default: [
    offerHistoryColumns.historyCreatedAt,
    offerHistoryColumns.historyCreatedBy,
    offerHistoryColumns.modifiedAt,
    offerHistoryColumns.id,
    offerHistoryColumns.tapOfferStatus,
    offerHistoryColumns.offerTableRowRlId,
    offerHistoryColumns.licensingJobId,
    offerHistoryColumns.dealId,
    offerHistoryColumns.dealName,
    offerHistoryColumns.catalogId,
    offerHistoryColumns.catalogName,
    offerHistoryColumns.readyToPublish,
    offerHistoryColumns.offerStatus,
    offerHistoryColumns.dateTaken,
    offerHistoryColumns.media,
    offerHistoryColumns.territory,
    offerHistoryColumns.languages,
    offerHistoryColumns.format,
    offerHistoryColumns.termStart,
    offerHistoryColumns.termEnd,
    offerHistoryColumns.startDateStatus,
    offerHistoryColumns.endDateStatus,
    offerHistoryColumns.rating,
    offerHistoryColumns.rateCardType,
    offerHistoryColumns.rateCardId,
    offerHistoryColumns.rateCardName,
    offerHistoryColumns.windows,
    offerHistoryColumns.windowNum,
    offerHistoryColumns.tier,
    offerHistoryColumns.licenseFee,
    offerHistoryColumns.minDeemedPrice,
    offerHistoryColumns.seasonPassAmt,
    // episodeTier is in withEpisodeFeature
    offerHistoryColumns.pmxPlatform,
    offerHistoryColumns.currency,
    offerHistoryColumns.percentageSplit,
    offerHistoryColumns.emaPriceType,
    // episodeEmaPriceType is in withEpisodeFeature
    offerHistoryColumns.viewingPeriod,
    offerHistoryColumns.preSell,
    offerHistoryColumns.subLanguage,
    offerHistoryColumns.dubLanguage,
    offerHistoryColumns.tprProgramName,
    offerHistoryColumns.ocad,
    offerHistoryColumns.suppressionLiftDate,
    offerHistoryColumns.exclusivity,
    offerHistoryColumns.holdbackLanguages,
    offerHistoryColumns.languageAvailsDisplay,
    offerHistoryColumns.availsTypeOverride,
    offerHistoryColumns.informationalRestrictions,
    offerHistoryColumns.message,
  ],
  withEpisodeFeature: [
    offerHistoryColumns.episodeTier,
    offerHistoryColumns.episodeEmaPriceType,
  ],
});
